export const BRAND_COLOR = process.env.REACT_APP_BRAND_COLOR || 'green';
export const SITE_FAVICON = process.env.REACT_APP_SITE_FAVICON || '';
export const SITE_ICON = process.env.REACT_APP_SITE_ICON || '/img/icon.png';
export const SITE_LOGO = process.env.REACT_APP_SITE_LOGO || '/img/icon.png';
export const SITE_TITLE = process.env.REACT_APP_SITE_TITLE || '';
